import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerCell.scss';


const DatePickerCell = ({ row, column, updateRow,tempId, formatDateForInput }) => {
  const rowId = row.original.id || row.original.tempId;


  // Parse date from string (supports YYYY-MM-DD and DD/MM/YYYY)
  const parseDate = (input) => {
    if (!input || input.trim() === '') return null;
    const trimmedInput = input.trim();


    // Handle YYYY-MM-DD (from API or state)
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedInput)) {
      const [year, month, day] = trimmedInput.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    }


    // Handle DD/MM/YYYY (user input)
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmedInput)) {
      const [day, month, year] = trimmedInput.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    }


    return null;
  };


  // Format date for display (DD/MM/YYYY)
  const formatDateForDisplay = (date) => {
    if (!date || isNaN(date.getTime())) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  // Format date for state update (YYYY-MM-DD)
  const formatDateForUpdate = (date) => {
    if (!date || isNaN(date.getTime())) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  // Initialize state
  const initialDate = parseDate(row.original[column.id]);
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [inputValue, setInputValue] = useState(formatDateForDisplay(initialDate));
  const [error, setError] = useState(null);


  // Sync with parent state changes
  useEffect(() => {
    const newDate = parseDate(row.original[column.id]);
    const newDateTime = newDate ? newDate.getTime() : null;
    const selectedDateTime = selectedDate ? selectedDate.getTime() : null;


    if (newDateTime !== selectedDateTime) {
      setSelectedDate(newDate);
      setInputValue(formatDateForDisplay(newDate));
      setError(null);
    }
  }, [row.original[column.id]]);


  // Handle date selection from DatePicker
  const handleChange = (date) => {
    setError(null);
    if (date && !isNaN(date.getTime())) {
      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      setSelectedDate(localDate);
      setInputValue(formatDateForDisplay(localDate));
      updateRow(rowId, column.id, formatDateForUpdate(localDate));
    } else {
      setSelectedDate(null);
      setInputValue('');
      updateRow(rowId, column.id, '');
    }
  };


  // Handle raw input (typing)
  const handleChangeRaw = (e) => {
    const input = e.target.value;
    setInputValue(input);
    const parsed = parseDate(input);
    if (parsed && !isNaN(parsed.getTime())) {
      setError(null);
      setSelectedDate(parsed);
      updateRow(rowId, column.id, formatDateForUpdate(parsed));
    } else if (!input) {
      setError(null);
      setSelectedDate(null);
      updateRow(rowId, column.id, '');
    } else {
      setError('Invalid date format. Use DD/MM/YYYY.');
    }
  };


  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        dateFormat="dd/MM/yyyy"
        placeholderText="DD/MM/YYYY"
        className={`custom-datepicker ${error ? 'error' : ''}`}
        title="Enter date in DD/MM/YYYY format"
        popperPlacement="bottom-start"
        onChangeRaw={handleChangeRaw}
        value={inputValue}
        calendarStartDay={1}
      />
      {error && (
        <small style={{ color: 'red', fontSize: '0.8em', display: 'block', textAlign: 'center' }}>
          {error}
        </small>
      )}
    </div>
  );
};


export default DatePickerCell;